<template>
  <div
    v-if="state && items.length > 0"
    class="ais-RefinementList"
  >
    <h3
      class="h6 muted text-uppercase"
      style="letter-spacing: var(--letter-spacing-2xl)"
    >
      Categories
    </h3>

    <ul
      class="icons-facets-group-categories"
      style="--list-style-type: none; --padding-left: 0; --margin-top: 0; --margin-bottom: var(--spacing-2xl)"
    >
      <li
        v-for="item in items"
        :key="item.value"
        class="wrap-icons-facet-input margin-bottom-5xs"
      >
        <input
          :id="`icons-category-${item.label}`"
          type="checkbox"
          name="categories"
          class="with-icon"
          :checked="item.isRefined"
          @click="selectCategory(item.value)"
        />

        <label
          :for="`icons-category-${item.label}`"
          class="icons-facet icons-facet-input margin-0 flex-row size-sm flex-items-baseline"
          style="padding: var(--spacing-2xs) var(--spacing-sm); cursor: pointer; display: flex !important"
        >
          <span class="icons-facet-affordance position-relative margin-right-sm">
            <i :class="`fas fa-${categoryIcon(item.value)} fa-fw unchecked-icon`" />
            <font-awesome-icon
              :icon="$v6.regular.faSquare"
              fixed-width
              class="hover-icon"
            />
            <font-awesome-icon
              :icon="$v6.solid.faSquareCheck"
              fixed-width
              class="checked-icon"
            />
          </span>

          <span style="flex-grow: 1; flex-shrink: 1; flex-basis: auto">
            <span class="sr-only">
              <template v-if="item.isRefined">Showing&nbsp;</template>
              <template v-else>Show&nbsp;</template>
            </span>
            <span class="text-capitalize">{{ categoryLabel(item.value) }}</span>
            <span class="sr-only">&nbsp;category icons</span>
          </span>

          <span class="icons-facet-count margin-left-sm">
            {{ item.count.toLocaleString() }}
            <span class="sr-only">matching results</span>
          </span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script>
  import { createWidgetMixin } from 'vue-instantsearch'
  import { connectRefinementList } from 'instantsearch.js/es/connectors'

  const categoryIcons = require('app/views/icons/category-figures/v6.json')
  const categoryIcons5 = require('app/views/icons/category-figures/v5.json')

  export default {
    name: 'CategoryFacets',

    mixins: [createWidgetMixin({ connector: connectRefinementList })],

    props: {
      selectedCategory: {
        type: String
      }
    },

    computed: {
      activeVersion() {
        return this.$releases.active.versionParts.major
      },

      currentIconAssets() {
        if (this.activeVersion == 5) {
          return categoryIcons5
        } else {
          return categoryIcons
        }
      },

      widgetParams() {
        return {
          attribute: 'categories',
          limit: 100,
          sortBy: this.sortBy(),
          operator: 'and'
        }
      },

      items() {
        return this.state != null ? this.state.items : null
      }
    },

    watch: {
      selectedCategory(newValue, _oldValue) {
        this.selectSingleCategory(newValue)
      }
    },

    methods: {
      categoryIcon(category) {
        const icon = this.currentIconAssets.filter((c) => {
          return c.id == category
        })[0]
        return icon ? icon.icon : 'bell-on'
      },

      categoryLabel(category) {
        const icon = this.currentIconAssets.filter((c) => {
          return c.id == category
        })[0]

        return icon ? icon.label : category
      },

      sortBy() {
        //return this.orderedByName == true ? ['name:asc'] : ['count:desc']
        return ['name:asc']
      },

      selectCategory(value) {
        this.state.refine(value)
        this.$emit('scrollTop')
        this.$emit('closeIcon')

        if (value !== 'None') {
          this.$posthog.capture('icon_search:category_facet_button_click', { facet: value })
        }
      },

      selectSingleCategory(value) {
        // Clear out current category refinements
        this.items.forEach((item) => {
          if (item.isRefined) {
            this.state.refine(item.value)
          }
        })

        this.state.refine(value)
        this.$emit('scrollTop')
        this.$emit('closeIcon')
      }
    }
  }
</script>
